import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Message } from '../../../models';
import { IModalData } from './videoconference-main-modal.model';
import { UtilsService } from '../../../services/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class VideoconferenceMainModalService {
  private fileDataMessage?: Message;
  private modalDataBS: BehaviorSubject<IModalData>;
  private modalData$: Observable<IModalData>;
  private fileOperationsModalTitle = '';

  constructor(
    private readonly utilsService: UtilsService
  ) {
    this.modalDataBS = new BehaviorSubject({
      title: ''
    });
    this.modalData$ = this.modalDataBS.asObservable();
  }

  setFilesOperationsData(data?: Message) {
    this.fileDataMessage = data;
  }

  getModalData(): Observable<IModalData> {
    return this.modalData$;
  }

  openModal(content?: IModalData) {
    //file opretions modal (download view)
    if (this.fileDataMessage) {
      let urlBlob;
      if (this.fileDataMessage.img) {
        urlBlob = this.fileDataMessage.img;
      } else {
        const blob = this.utilsService.datatoBlob((this.fileDataMessage.doc as string), (this.fileDataMessage.type as string));
        urlBlob = this.utilsService.blobToUrl(blob, (this.fileDataMessage.fileName as string), (this.fileDataMessage.type as string));
      }
      const data = Object.assign(this.fileDataMessage, {urlBlob});
      if (this.fileDataMessage.fileName) {
        this.modalDataBS.next({
          title: this.fileDataMessage.fileName,
          data
        });
      }
    } else {
      //normal modal
      if (content && content.title !== '') {
        this.modalDataBS.next(content);
      }
    }
  }

  closeModal(data?: any){
    if(data && this.fileDataMessage) {
      const fileData = this.utilsService.copyDeepObject(this.fileDataMessage);
      this.utilsService.openFile(fileData.doc, fileData.fileName, fileData.type);
      this.destroyFilesOperationsData();
    } else {
      this.destroyFilesOperationsData();
    }
  }

  destroyFilesOperationsData(){
    this.modalDataBS.next({
      title: ''
    });
    this.fileDataMessage = undefined;
  }

  viewFile(){
    // if (this.fileDataMessage.id) {
    //   let type = null;
    //   if (this.fileDataMessage.type.includes('image')) {
    //     type = 'image/' + this.fileDataMessage.fileName.split('.')[1];
    //   } else {
    //     type = 'application/' + this.fileDataMessage.fileName.split('.')[1];
    //   }
    //   // this.getChatFile(this.fileDataMessage, true);
    // } else {
    //   this.utilsService.openFile(this.fileDataMessage.doc, this.fileDataMessage.fileName, this.fileDataMessage.type);
    // }
  }
  downloadFile(){
  //   if (this.fileDataMessage.id) {
  //     let type = null;
  //     if (this.fileDataMessage.type.includes('image')) {
  //       type = 'image/' + this.fileDataMessage.fileName.split('.')[1];
  //     } else {
  //       type = 'application/' + this.fileDataMessage.fileName.split('.')[1];
  //     }
  //     // this.getChatFile(this.fileDataMessage, true);
  //   } else {
  //     this.utilsService.openFile(this.fileDataMessage.doc, this.fileDataMessage.fileName, this.fileDataMessage.type);
  //   }
  }
}
